import Vue from 'vue'
/* import { use } from 'echarts/core'

// renderer
import { CanvasRenderer } from 'echarts/renderers'
// chart types
import { BarChart, PieChart, LineChart } from 'echarts/charts'
// components
import { GridComponent, LegendComponent, ToolboxComponent, TitleComponent } from 'echarts/components'
 */

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart, PieChart } from "echarts/charts";
import {
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent,
	ToolboxComponent,
	DataZoomComponent,
	DatasetComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
	// renderer
	CanvasRenderer,
	// chart types
	PieChart,
	LineChart,
	BarChart,
	// components
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent,
	ToolboxComponent,
	DataZoomComponent,
	DatasetComponent
]);
Vue.component('v-chart', VChart)



// WEBPACK FOOTER //
// ./src/libs/echart.js